import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, map, throwError } from "rxjs";
import { AppConfigurationService } from "../../../erp/services/base/appConfiguration.service";

@Injectable({
  providedIn: "root",
})
export class QuizTesteVitalidadeService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService
  ) { }

  buscarPerguntas(): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/VitalityQuiz`)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err =>
          throwError(() => ({
            message: err.message,
            status: err.status,
            error: err.error,
          }))
        )
      );
  }

    iniciarQuiz(dadosUsuario: any): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/VitalityQuiz/StartVitalityQuiz`, dadosUsuario)
      .pipe(
        map((response) => {
          return response;
        }),
       catchError(err =>
          throwError(() => ({
            message: err.message,
            status: err.status,
            error: err.error,
          }))
        )
      );
  }

  responderQuiz(resposta: any): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/VitalityQuiz/AnswerQuestion`, resposta)
      .pipe(
        map((response) => {
          return response;
        }),
         catchError(err =>
          throwError(() => ({
            message: err.message,
            status: err.status,
            error: err.error,
          }))
        )
      )
  }

  finalizarQuiz(idUsuario: string): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/VitalityQuiz/FinishQuiz?vitalityQuizPersonalDataId=${idUsuario}`, '')
      .pipe(
        map(response => response),
        catchError(err =>
          throwError(() => ({
            message: err.message,
            status: err.status,
            error: err.error,
          }))
        )
      );
  }

  exportarRelatorio(startDate: string, endDate: string, dados: any = null): Observable<Blob> {
    const url = `${this.appConfigurationService.apiBaseUrl}/VitalityQuiz/ExportExcel?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;

    return this.httpClient
      .post(url, dados, {
        responseType: 'blob',
      })
      .pipe(
        map(response => response),
        catchError(err =>
          throwError(() => ({
            message: err.message,
            status: err.status,
            error: err.error,
          }))
        )
      );
  }
}
